class StyleService {
  public static shouldNotForwardProps(propKeys: PropertyKey[]) {
    return (propKey: PropertyKey) => !propKeys.includes(propKey);
  }

  public static pxToRem(pxValue: number, baseFontSize: number = 16): string {
    const remValue = pxValue / baseFontSize;

    return remValue.toFixed(2) + 'rem';
  }
}

export default StyleService;
